module.exports = __webpack_public_path__ + "static/media/ws.e45b5a27.svg";